const initialState = {
	isLoading: false,
    list: [],
	totalsize: 0
};

function transactionReducer(state = initialState, action) {
    switch (action.type) {
		case 'LOADING_ADMIN_TRANSACTION':
			return {
				...state,
				isLoading: action.payload
			};
		case 'ADMIN_TRANSACTION_USER':
			return {
				...state,
				list: action.payload.list,
				totalsize: action.payload.totalsize
			};
		default:
		  return state;
    }
}

export default transactionReducer;
